import script from "./ciif.vue?vue&type=script&setup=true&lang=js"
export * from "./ciif.vue?vue&type=script&setup=true&lang=js"

import "./ciif.vue?vue&type=style&index=0&id=741e482b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-741e482b"]])

export default __exports__